import axios from 'axios';
import { Bank, Branch } from '@/types';

export const fetchAllBanks = async (
  signal?: AbortSignal
): Promise<Bank[]> => {
  let fetchedBanks: Bank[] = [];
  let currentPage = 1;

  while (currentPage <= 24) {
    const api = `https://bank.teraren.com/banks.json?page=${currentPage}`;
    const response = await axios.get<Bank[]>(api, { signal });
    const data = response.data;

    if (data && data.length > 0) {
      fetchedBanks = fetchedBanks.concat(data);
      currentPage += 1;
    } else {
      break;
    }
  }
  return fetchedBanks;
};

export const fetchAllBranches = async (bankCode: string): Promise<Branch[]> => {
  let allBranches: Branch[] = [];
  let currentPage = 1;
  let hasMore = true;

  while (hasMore) {
    const api = `https://bank.teraren.com/banks/${bankCode}/branches.json?page=${currentPage}`;
    const response = await axios.get<Branch[]>(api);
    const data = response.data;

    if (data && data.length > 0) {
      allBranches = allBranches.concat(data);
      currentPage++;
    } else {
      hasMore = false;
    }
  }
  return allBranches;
};

export const fetchBranchByCode = async (
  bankCode: string,
  branchCode: string
): Promise<Branch | null> => {
  const api = `https://bank.teraren.com/banks/${bankCode}/branches/${branchCode}.json`;
  try {
    const response = await axios.get<Branch>(api);
    return response.data;
  } catch (error) {
    return null;
  }
};
